import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Wifi, WifiOff } from "@mui/icons-material";
import { IconButton } from "@mui/material";

const Online1Widget = ({ widget, onValueUpdate }) => {
  const [isOnline, setIsOnline] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      if (widget.items.$w1.value === "online") {
        setIsOnline(true);
      } else {
        setIsOnline(false);
      }
    }
    return () => {};
  }, [widget]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
      }}
    >
      <Box
        sx={{
          height: "100%",
          aspectRatio: "1/1",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <IconButton
          sx={{
            width: "100%",
            height: "100%",
            padding: "4px",
            backgroundColor: isOnline
              ? "rgba(76, 175, 80, 0.1)"
              : "rgba(244, 67, 54, 0.1)",
            "&:hover": {
              backgroundColor: isOnline
                ? "rgba(76, 175, 80, 0.1)"
                : "rgba(244, 67, 54, 0.1)",
            },
          }}
        >
          {isOnline ? (
            <Wifi
              style={{
                width: "100%",
                height: "100%",
                color: "#4CAF50",
              }}
            />
          ) : (
            <WifiOff
              style={{
                width: "100%",
                height: "100%",
                color: "#F44336",
              }}
            />
          )}
        </IconButton>
      </Box>
    </Box>
  );
};

export default Online1Widget;
